<template>
  <div class="login-container">
    <!-- 左上角公司信息 -->
    <!-- <div class="company-header">
      <img src="../../assets/404_images/logo.png" alt="" class="company-logo" />
      <div class="right">
        <div class="company-name">河南麦趣文化传媒有限公司</div>
        <div class="company-slogan">Henan Maiqu Culture Media Co., Ltd.</div>
      </div>
    </div> -->

    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
      label-position="left">
      
      <div class="title-container">
        <div class="logo-container">
          <img src="../../assets/logo.png" alt="" class="form-logo" />
        </div>
        <h3 class="title">颜盟用户管理中心</h3>
        <div class="sub-title">Welcome to use</div>
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <i class="el-icon-user icon-black"></i>
        </span>
        <el-input ref="username" v-model="loginForm.username" placeholder="请输入用户名" name="username" type="text"
          tabindex="1" auto-complete="on" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <i class="el-icon-lock icon-black"></i>
        </span>
        <el-input :key="passwordType" ref="password" v-model="loginForm.password" :type="passwordType"
          placeholder="请输入密码" name="password" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" />
        <span class="show-pwd" @click="showPwd">
          <i :class="passwordType === 'password' ? 'el-icon-view icon-black' : 'el-icon-minus icon-black'"></i>
        </span>
      </el-form-item>


      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin">登录</el-button>


    </el-form>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/user'
import { setToken } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
   
    return {
      loginForm: {
        username: '',
        password: '',
      
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
       
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      captchaUrl: '',
      captchaUuid: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
   
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          // 构建登录请求参数
          const loginData = {
            mobile: this.loginForm.username,
            password: this.loginForm.password,
          }

          this.loading = true
          try {
            const res = await postAction('/api/center/login', loginData)
            console.log(res, '登录响应')

            if (res.code === 200) {
              // 检查token是否存在
              if (res.data.token) {
                localStorage.setItem('token', res.data.token)
                // 保存 token 到 Cookie
                setToken(res.data.token)
                this.$message.success('登录成功')
                // 登录成功后跳转到首页
                this.$router.push({ path: '/' })
              } else {
                this.$message.error('登录失败！')
               
              }
            } else {
              this.$message.error(res.message || '登录失败')
             
            }
          } catch (error) {
            console.error('登录失败:', error)
            this.$message.error('登录失败，请检查用户名、密码')
          
          } finally {
            this.loading = false
          }
        } else {
          console.log('表单提交错误!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #000;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  background: url('https://www.quying666.com:8001/static/png/login-background-BtsFdyNx.png') no-repeat 100% 100%;

  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    background-color: transparent;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      // caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #FFF inset !important;
        -webkit-text-fill-color: #000 !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(220, 223, 230, 1);
    // background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #000;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 400px;
    max-width: 100%;
    padding: 35px 35px 0;
    margin: 210px auto 0;
    overflow: hidden;
    background: linear-gradient(to bottom, rgb(182, 197, 255), rgb(255, 255, 255), rgb(255, 255, 255), rgb(255, 255, 255), rgb(255, 255, 255), rgb(255, 255, 255));
    border-radius: 20px;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #000;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .company-header {
    position: absolute;
    top: 30px;
    left: 30px;
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 10;

    .company-logo {
      width: 70px;
      height: 70px;
    }

    .right {
      .company-name {
        font-weight: bold;
        font-size: 24px;
        color: rgba(113, 91, 255, 1);
       
        transform: skew(-20deg);
      }

      .company-slogan {
        font-size: 20px;
        margin-top: 8px;
        color: rgba(113, 91, 255, 1);
      }
    }

  }

  .title-container {
    position: relative;

    .logo-container {
      text-align: center;
      margin-bottom: 20px;

      .form-logo {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      }
    }

    .title {
      font-size: 22px;
      color: $light_gray;
      margin: 0px auto 10px auto;
      text-align: center;
      font-weight: bold;
    }
    .sub-title{
      font-size: 14px;
      color: $dark_gray;
      margin: 0px auto 10px auto;
      text-align: center;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }

  .captcha {
    position: absolute;
    right: 10px;
    top: 5px;
    cursor: pointer;

    img {
      width: 100px;
      height: 37px;
      border-radius: 4px;
      background-color: #f5f5f5;
    }
  }

  .icon-black {
    color: #000 !important;
    font-size: 16px;
  }
}

/* 手机端适配 */
@media (max-width: 768px) {
    
  .login-container {
   
    .company-header {
      position: relative;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      flex-direction: column;
      text-align: center;
      gap: 8px;

      .company-logo {
        width: 50px;
        height: 50px;
      }

      .right {
        .company-name {
          font-size: 18px;
          transform: none;
        }

        .company-slogan {
          font-size: 14px;
          margin-top: 4px;
        }
      }
    }

    .login-form {
      position: relative;
      width: 90%;
      max-width: 320px;
      padding: 25px 20px 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      background: linear-gradient(to bottom, rgb(182, 197, 255), rgb(255, 255, 255));
      border-radius: 15px;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }

    .title-container {
      .logo-container {
        margin-bottom: 15px;

        .form-logo {
          width: 45px;
          height: 45px;
        }
      }

      .title {
        font-size: 20px;
        margin-bottom: 8px;
      }

      .sub-title {
        font-size: 12px;
        margin-bottom: 15px;
      }
    }

    .el-form-item {
      margin-bottom: 18px;
      background-color: #fff;
      .el-input {
        width: 80%;
        input {
          padding: 12px 5px 12px 12px;
          font-size: 14px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 12px;
      width: 28px;

      .icon-black {
        font-size: 14px;
      }
    }

    .show-pwd {
      right: 8px;
      top: 8px;
      font-size: 14px;
    }

    .captcha {
      right: 8px;
      top: 6px;

      img {
        width: 80px;
        height: 35px;
      }
    }

    .el-button {
      padding: 12px 20px;
      font-size: 16px;
      margin-top: 10px;
    }
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
 
  .login-container {
   
    .login-form {
      width: 95%;
      padding: 20px 15px 0;
      margin-top: 125px;
    }

    .title-container {
      .title {
        font-size: 18px;
      }

      .sub-title {
        font-size: 11px;
      }
    }

    .el-form-item {
      background-color: #fff;
      .el-input {
        width: 78%;
        input {
          padding: 10px 5px 10px 10px;
        }
      }
    }

    .svg-container {
      padding: 5px 5px 5px 10px;
      width: 25px;
    }

    .captcha img {
      width: 70px;
      height: 32px;
    }
  }
}
</style>
